'use strict';

var EditLanIsolation = require('actionGroups/lanIsolation/LanIsolation');

module.exports = {
  Model: EditLanIsolation,
};
